import { DataSource, QueryRunner } from "typeorm";
import { require as appRootImport } from 'app-root-path';

const eloquentconfig = appRootImport('eloquent.config.js')

let dataSource: Record<string, DataSource> = {};

export const createConnection = async (success?: ((value: DataSource | DataSource[]) => void | PromiseLike<void>), error?: ((reason: any) => void | PromiseLike<void>)) => {
    if(Array.isArray(eloquentconfig)) {

        dataSource = eloquentconfig.reduce((result, { name, ...config }) => {
            result[name] = new DataSource(config)
            return result
        }, dataSource)

        await Promise.all(Object.keys(dataSource).map((name) => dataSource[name].initialize()))
        .then(success)
        .catch(error)

    } else {
        dataSource.default = new DataSource(eloquentconfig)
    
        await dataSource.default
            .initialize()
            .then(success)
            .catch(error)
    }

    return dataSource
}

let connectionexist: boolean = false

export const createConnectionIfNotExist = async (success?: ((value: DataSource | DataSource[]) => void | PromiseLike<void>), error?: ((reason: any) => void | PromiseLike<void>)) => {
    
    if(connectionexist === false) {

        await createConnection(success, error)
        connectionexist = true

    } 
    
    return Promise.resolve(true)
}

export const getDataSource = (dataSourceName: string = 'default') => {

    if(!dataSource[dataSourceName]) {
        throw Error(`Trying to get data source: "${dataSourceName}" which doesn't exist or not been initialized.`)
    }

    return dataSource[dataSourceName]
}

export const setDataSource = (name: string, source: DataSource) => {
    dataSource[name] = source
}

export const getQueryBuilder = (dataSourceName: string = 'default', pool?: QueryRunner | null) => {

    if(!dataSource[dataSourceName]) {
        throw Error(`Trying to connect data source: "${dataSourceName}" which doesn't exist or not been initialized.`)
    }

    return pool ? dataSource[dataSourceName].createQueryBuilder(pool) : dataSource[dataSourceName].createQueryBuilder()
}

export class ConnectionPool {

    private dataSourceName: string;

    private queryRunner: QueryRunner;

    constructor (dataSourceName: string = 'default') {

        if(!dataSource[dataSourceName]) {
            throw Error(`Trying to use data source: "${dataSourceName}" which doesn't exist or not been initialized.`)
        }

        this.dataSourceName = dataSourceName

        this.queryRunner = dataSource[dataSourceName].createQueryRunner()
    }

    async open() {

        await this.queryRunner?.connect()
    }

    async close() {

        await this.queryRunner?.release()
    }

    getQueryRunner() {

        return this.queryRunner
    }

    getDataSourceName() {

        return this.dataSourceName
    }
}